import StucredLoginLayer from "./StucredLoginLayer"

const StucredLogin = () => {
  return (
    <div> <StucredLoginLayer/></div>
  )
}

export default StucredLogin